import type { Dispatch } from "redux";
import { getJetpackConfig } from "../../redux/jetpackConfig";
import TSUtils from "./TSUtils";
import {
  JETPACK_CONFIG,
  ONBOARDING,
  subscriptionByQuote
} from "../routes/routes";
import { buildPathWithTrackingId } from "../routing/routingUtils";
import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";

export function processPostSignIn(
  accountToDisplay: ManagedAccount,
  dispatch: Dispatch,
  history: any
) {
  if (
    !accountToDisplay.trackingID ||
    !accountToDisplay?.token ||
    !accountToDisplay?.businessUser
  ) {
    throw new Error("No business user");
  }

  getJetpackConfig(accountToDisplay)(dispatch);

  const isUsePromoCode2 =
    !!accountToDisplay.businessUser.tempsSubscriptionPromoCode2;

  const paramz = new URLSearchParams(window.location.search);
  paramz.delete("email");
  const planStr = paramz.get("planId");

  if (TSUtils.isHexObjectId(planStr)) {
    console.log("a");
    history.push(`${subscriptionByQuote}?${paramz.toString()}`);
  } else if (isUsePromoCode2) {
    console.log("b");
    history.push(`${subscriptionByQuote}`);
  } else if (accountToDisplay?.businessUser?.isOnboarded) {
    console.log("c");
    history.push(
      buildPathWithTrackingId(JETPACK_CONFIG, accountToDisplay?.trackingID)
    );
  } else {
    console.log("d");
    history.push(
      buildPathWithTrackingId(ONBOARDING, accountToDisplay?.trackingID)
    );
  }
}
